import Api from "../../../config/ApiConfig";
import * as types from "./types";

const apiUrls = {
  postMetaDataExtractor: "api/v1/extractors/metadata",
  getEXTTableMetaData: "api/v1/sources/metadata",
  putEXTTableMetaData: "api/v1/extractors/metadata/",
  foundryMetaData: "api/v1/sources/"
};

export const postMetaDataExtractor = (payload: types.IMetaDataExtractor) =>
  Api.post(apiUrls.postMetaDataExtractor, payload)
    .then((response) => { return response; })
    .catch((error) => { return error.response; });

export const putExtractorMetadata = (param: string, payload: types.IExtractorMetadataPutReq) =>
  Api.put(apiUrls.putEXTTableMetaData + `${param}`, payload)
    .then((response) => { return response })
    .catch((error) => { return error.response });

export const getExtTableMetaData = (payload: types.IEXTTableMetaDataParams) =>
  Api.get(apiUrls.getEXTTableMetaData + `/${payload.layer_id}/${payload.schema}?tableName=${encodeURIComponent(payload.table_name)}`)
    .then((response) => { return response; })
    .catch((error) => { return error.response; });

export const getFoundryMetaData = (payload: types.IFoundryMetaDataParams) =>
  Api.get(apiUrls.foundryMetaData + `${payload.src_id}/foundry/${payload.dataset_rid}`)
    .then((response) => { return response; })
    .catch((error) => { return error.response; });